(ns practitest.frontend.xbot.agents-view.av-utilization-charts
  (:require
   ["react-c3js" :default C3Chart]
   [practitest.frontend.xbot.agents-view.av-common :as av-common]
   [practitest.frontend.components.charts :as charts]))

(defn display-load-row [load title class]
  [:tr.table-body
   [:td.load title]
   [:td.load {:class class}
    (.toFixed load 2)]])

(defn display-load-bars [load]
  [:>
   C3Chart
   {:style  {:width   "100px"
             :padding "0"}
    :data   {:columns [[:load1 (:load1 load)]
                       [:load5 (:load5 load)]
                       [:load15 (:load15 load)]]
             :type    "bar"
             :labels  false
             :colors  {:load1  av-common/color-load1
                       :load5  av-common/color-load5
                       :load15 av-common/color-load15}}
    :legend {:show false}
    :axis   {:rotated true
             :x       {:show false
                       :type "category"}
             :y       {:show false}}
    :bar    {:width 25
             :space 0.4}}])

(defn display-avg-load [{:keys [load]}]
  [:div.flex
   [:div.no-border.flex
    {:style {:width   "160px"
             :padding "0"}}
    [:table.table.table-condensed.no-background
     [:thead
      [:tr
       [:th.no-border.load "Average Load"]]
      [display-load-row (:load1 load) "Last 1 minute" "load1"]
      [display-load-row (:load5 load) "Last 5 minute" "load5"]
      [display-load-row (:load15 load) "Last 15 minutes" "load15"]]]]
   [display-load-bars load]])

(defn display-cpu-old [{:keys [id cpu]}]
  [:div
   {:style {:width       "250px"
            :margin-left "-15px"}}
   (for [[i cpu] (map-indexed vector cpu)]
     ^{:key (str id "-cpu-" i)}
     [:>
      C3Chart
      {:data       {:columns [[(str "CPU" i) cpu]]
                    :type    "gauge"}
       :transition {:duration 500}}])])

(defn display-cpu [{:keys [id cpu]}]
  [:div {:style {:max-width "120px"}}
   (for [[i cpu] (map-indexed vector cpu)]
     ^{:key (str id "-cpu-" i)}
     [charts/percentage-gauge
      {:percentage (/ cpu 100.0)
       :title-fn (fn [percentage]
                   (str percentage "%"))
       :subtitle-fn (fn [_percentage]
                      (str "CPU" i " utilization"))}])])

(defn display-memory [{:keys [memory]}]
  [:div {:style {:max-width "120px"}}
   [charts/percentage-gauge
    {:percentage  (/ (:used memory) 100.0)
     :title-fn    (fn [percentage]
                    (str percentage "%"))
     :subtitle-fn (fn [_percentage]
                    (str "%memory (of "
                         (int (/ (:total memory) 1073741824))
                         "GB)"))}]])

(defn display-utilization-charts [{:keys [online? load] :as agent}]
  [:div.col-sm-12.col-md-6.col-lg-6.no-padding-sides
   [:div.top-text.col-sm-12.col-md-12.col-lg-12
    [av-common/agent-view-titles "Utilization charts: "]
    (when online?
      [:div
       (when load
         [display-avg-load agent])
       [:div.d-flex
        [:div.d-flex
         [display-cpu agent]
         [display-memory agent]]]])]])
